module.exports = __webpack_public_path__ + "img/Drivers_Municipal_&_Industrial_Conditions.76a3e454.jpg";